export default "__VITE_ASSET__8d514f06__"